import { createReducer, createSelector } from '@reduxjs/toolkit';
import { all, call, takeEvery, fork } from 'redux-saga/effects';
import {
  getVersionSuccess,
  getVersionInitialize,
  getVersionError,
} from '../actions/api';
import { VersionConnector } from '../connectors/versionConnector';
import { generateGetAllApiCall } from '../helpers/sagaHelpers';

// -------- Overview --------

// The following endpoints exists
//  - GET /version

// -------- Reducer --------
const versionReducer = createReducer(
  {
    version: '',
    isFetchingVersion: false,
  },
  (builder) => {
    builder.addCase(getVersionSuccess, (state, action) => {
      const version = action.payload?.requestData;
      state.isFetchingVersion = false;
      state.version = version;
    });
    builder.addCase(getVersionInitialize, (state) => {
      state.isFetchingVersion = true;
    });
    builder.addCase(getVersionError, (state) => {
      state.isFetchingVersion = false;
    });
  },
);

// -------- Sagas --------
export function* versionSaga() {
  yield all([fork(getVersionSaga)]);
}

function* getVersionSaga() {
  yield takeEvery(
    getVersionInitialize.type,
    generateGetAllApiCall(VersionConnector, function* (connector) {
      return yield call([connector, connector.getVersion]);
    }),
  );
}

// -------- Selectors --------
const selectVersionSlice = (state) => state['api']['version'];

const versionSelector = createSelector(
  selectVersionSlice,
  (state) => state.version,
);

const isFetchingVersionSelector = createSelector(
  selectVersionSlice,
  (state) => state.isFetchingVersion,
);

// -------- Exporting --------
export { versionSelector, isFetchingVersionSelector };
export default versionReducer;
